import React, { createContext, useState, useEffect } from "react";

export const FirmwareContext = createContext();

export const FirmwareProvider = ({ children }) => {
    const [firmwares, setFirmwares] = useState([]);

    useEffect(() => {
        fetch("https://pagina-firmware.onrender.com/api/firmwares")
            .then((res) => res.json())
            .then((data) => setFirmwares(data))
            .catch((err) => console.error("Error al obtener datos de Firmwares", err));
    }, []);

    return (
        <FirmwareContext.Provider value={firmwares}>
            {children}
        </FirmwareContext.Provider>
    );
};